// @ts-nocheck

import { colors, RISK_COLORS } from '@lmc/common/constants'
import dayjs from 'dayjs'
import _ from 'lodash'
import { RISK_LEVELS } from '../../common/constants'
import {
  getStoolColor,
  isStool,
  isStoolBloody,
  isStoolMucus,
  isStoolOffensive,
  StoolColormap
} from '../../common/utils'
import Logo from './Logo'

export const Header = ({
  title,
  subtitle,
  date,
  dateFormat = 'DD MMM YYYY'
}) => {
  const dateHeading = date
    ? {
        margin: [0, 0, 0, 0],
        style: ['h2'],
        text: dayjs(date).format(dateFormat)
      }
    : null

  const subtitleRow = subtitle
    ? {
        margin: [0, 0, 0, 30],
        style: ['h2'],
        text: subtitle
      }
    : null

  const titleBottomMargin = subtitle ? 0 : 30
  return {
    columns: [
      [
        dateHeading,
        {
          margin: [0, 0, 0, titleBottomMargin],
          style: ['h1'],
          text: title
        },
        subtitleRow
      ],
      {
        width: 90,
        alignment: 'right',
        margin: [0, 4, 0, 0],
        image: Logo
      }
    ]
  }
}

export const StoolTable = (row, dateFormat) => ({
  style: 'table',
  table: {
    layout: {
      defaultBorder: false
    },
    headerRows: 1,
    widths: [
      'auto',
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      'auto',
      'auto',
      'auto',
      'auto',
      90,
      'auto',
      'auto'
    ],
    body: [
      [
        {
          text: 'Time',
          style: 'tableHeaderSmall',
          alignment: 'center'
        },
        {
          text: 'Bristol Type',
          style: 'tableHeaderSmall',
          alignment: 'center',
          colSpan: 7
        },
        {},
        {},
        {},
        {},
        {},
        {},
        {
          text: 'Blood',
          style: 'tableText',
          alignment: 'center'
        },
        {
          text: 'Mucus',
          style: 'tableText',
          alignment: 'center'
        },
        {
          text: 'Offensive',
          style: 'tableText',
          alignment: 'center'
        },
        {
          text: 'Color',
          style: 'tableText',
          alignment: 'center'
        },
        {
          text: 'Note',
          style: 'tableHeaderSmall',
          alignment: 'center'
        },
        {
          text: 'Carer',
          style: 'tableHeaderSmall',
          alignment: 'center'
        },
        {
          text: 'Revision',
          style: 'tableHeaderSmall',
          alignment: 'center'
        }
      ],
      [
        {},
        {
          text: 1,
          style: 'tableTextSmall',
          alignment: 'center'
        },
        {
          text: 2,
          style: 'tableTextSmall',
          alignment: 'center'
        },
        {
          text: 3,
          style: 'tableTextSmall',
          alignment: 'center'
        },
        {
          text: 4,
          style: 'tableTextSmall',
          alignment: 'center'
        },
        {
          text: 5,
          style: 'tableTextSmall',
          alignment: 'center'
        },
        {
          text: 6,
          style: 'tableTextSmall',
          alignment: 'center'
        },
        {
          text: 7,
          style: 'tableTextSmall',
          alignment: 'center'
        },
        {},
        {},
        {},
        {},
        {},
        {},
        {}
      ],
      ...row.logs.map((log) => {
        const type = _.get(log, 'measurements.stool.value')
        const isBloody = isStoolBloody(log)
        const isMucus = isStoolMucus(log)
        const isOffensive = isStoolOffensive(log)
        const stoolColor = getStoolColor(log)
        const highlight = colors.darkgrey
        const types = [1, 2, 3, 4, 5, 6, 7]
        return [
          {
            text: dayjs(log.timeLogged).format(dateFormat || 'HH:mm DD/MM/YY'),
            style: 'tableText'
          },
          ...types.map((t) =>
            type === t
              ? {
                  text: 'X',
                  style: 'whiteTableText',
                  fillColor: StoolColormap[t]
                }
              : ''
          ),
          {
            text: isBloody ? 'X' : '',
            fillColor: isBloody ? highlight : null,
            style: 'whiteTableText'
          },
          {
            text: isMucus ? 'X' : '',
            fillColor: isMucus ? highlight : null,
            style: 'whiteTableText'
          },
          {
            text: isOffensive ? 'X' : '',
            fillColor: isOffensive ? highlight : null,
            style: 'whiteTableText'
          },
          {
            text: stoolColor || '',
            fillColor: stoolColor && stoolColor === 'black' ? highlight : null
          },
          {
            text: isStool(log) ? '' : `${log.title}. ${log.description}`,
            style: 'tableText'
          },
          {
            text:
              log.carerName +
              (log.witnessedBy && ` - witnessed by ${log.witnessedBy}`),
            style: 'tableTextSmall'
          },
          {
            text: log.editedBy
              ? `Edited by ${log.editedBy} on ${dayjs(log.editedAt).format(
                  'DD-MM-YYYY'
                )}`
              : '',
            style: 'tableTextSmall'
          }
        ]
      })
    ]
  }
})

export const LogListTable = (row, dateFormat) => ({
  style: 'table',
  table: {
    layout: {
      defaultBorder: false
    },
    headerRows: 1,
    widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto'],
    body: [
      [
        {
          text: 'Time',
          style: 'tableHeader',
          borderColor: 'red'
        },
        {
          text: 'Title',
          style: 'tableHeader'
        },
        {
          text: 'Description',
          style: 'tableHeader'
        },
        {
          text: 'Carer',
          style: 'tableHeader'
        },
        {
          text: 'Revision',
          style: 'tableHeader'
        },
        {
          text: 'Images',
          style: 'tableHeader'
        }
      ],
      ...row.logs.map((log) => {
        let timeLogged = dayjs(log.timeLogged).format(
          dateFormat || 'HH:mm DD/MM/YY'
        )

        if (log.originalTimeLog) {
          // CARE-1004: display original time logged in daily chart exports
          // TODO: originalTimeLog shouldn't be set unless the time has actually been changed manually
          const logSavedAt = dayjs(log.originalTimeLog).subtract(15, 'seconds')
          if (logSavedAt.isAfter(log.timeLogged)) {
            const original = dayjs(log.originalTimeLog)
            const isSameDay = dayjs(log.timeLogged).isSame(original, 'day')
            if (isSameDay)
              timeLogged += `, logged at ${original.format('HH:mm')}`
            else
              timeLogged += `, logged at ${original.format('HH:mm DD/MM/YY')}`
          }
        }

        const cols = [
          {
            text: timeLogged,
            style: 'tableText'
          },
          {
            text: log.title,
            style: 'tableText'
          },
          {
            text: log.description,
            style: 'tableText'
          },
          {
            text:
              log.carerName +
              (log.witnessedBy ? ` - witnessed by ${log.witnessedBy}` : ''),
            style: 'tableText'
          },
          {
            text: log.editedBy
              ? `Edited by ${log.editedBy} on ${dayjs(log.editedAt).format(
                  'DD-MM-YYYY'
                )}`
              : '',
            style: 'tableTextSmall'
          }
        ]
        if (log.picture1Base64) {
          const stack = []
          if (log.picture1Base64) {
            stack.push({
              image: log.picture1Base64,
              width: 100,
              margin: [0, 5, 0, 5]
            })
          }
          if (log.picture2Base64) {
            stack.push({
              image: log.picture2Base64,
              width: 100,
              margin: [0, 5, 0, 5]
            })
          }
          if (log.picture3Base64) {
            stack.push({
              image: log.picture3Base64,
              width: 100,
              margin: [0, 5, 0, 5]
            })
          }
          cols.push(stack)
        } else {
          cols.push({
            text: '',
            style: 'tableText'
          })
        }
        return cols
      })
    ]
  }
})

export const RiskOutcomeScore = (riskLevel, riskScore) => ({
  style: 'table',
  table: {
    headerRows: 1,
    widths: ['auto'],
    body: [
      [
        {
          text: `${riskScore} - ${RISK_LEVELS[riskLevel]}`,
          style: 'tableHeaderSmall'
        }
      ]
    ]
  },
  layout: {
    hLineColor: () => RISK_COLORS[riskLevel],
    vLineColor: () => RISK_COLORS[riskLevel],
    hLineWidth: () => 2,
    vLineWidth: () => 2
  }
})

export const NoteTable = (notes, dateFormat) => ({
  style: 'table',
  table: {
    layout: {
      defaultBorder: false
    },
    headerRows: 1,
    widths: ['auto', 'auto', '*'],
    body: [
      [
        {
          text: 'Time',
          style: 'tableHeader',
          borderColor: 'red'
        },
        {
          text: 'Created By',
          style: 'tableHeader'
        },
        {
          text: 'Note',
          style: 'tableHeader'
        }
      ],
      ...notes.map((note) => [
        {
          text: dayjs(note.createdOn).format(dateFormat || 'HH:mm DD/MM/YY'),
          style: 'tableText'
        },
        {
          text: `${note.carer.name.first} ${note.carer.name.last}`,
          style: 'tableText'
        },
        {
          text: note.note,
          style: 'tableText'
        }
      ])
    ]
  }
})

export const PageNumbers = (currentPage, pageCount) => ({
  text: `${currentPage.toString()} of ${pageCount}`,
  style: ['small', 'center'],
  margin: [0, 5]
})

export const Title = ({ title, style }) => ({ style, text: title })

export const TitleTextPair = ({ title, titleStyle, text, textStyle }) => [
  {
    style: titleStyle,
    text: title
  },
  {
    style: textStyle,
    text,
    margin: [0, 0, 0, 30]
  }
]

export const RiskAssessmentsTable = (riskAssessments) => ({
  style: 'table',
  table: {
    layout: {
      defaultBorder: false
    },
    headerRows: 1,
    widths: ['*', 'auto', 'auto', 'auto', 'auto'],
    body: [
      [
        {
          text: 'Title',
          style: 'tableHeader'
        },
        {
          text: 'Updated On',
          style: 'tableHeader'
        },
        {
          text: 'Updated By',
          style: 'tableHeader'
        },
        {
          text: 'Risk Level',
          style: 'tableHeader'
        },
        {
          text: 'Score',
          style: 'tableHeader'
        }
      ],
      ...riskAssessments.map((assessment) => {
        const reviewedOn = dayjs(
          assessment.reviewedOn || assessment.createdOn
        ).format('DD-MM-YYYY • HH:mm')
        const fullName =
          assessment.createdBy && assessment.createdBy.name
            ? `${assessment.createdBy.name.first} ${assessment.createdBy.name.last}`
            : ''

        return [
          {
            text: assessment.form ? assessment.form.name : '',
            style: 'tableText'
          },
          {
            text: reviewedOn,
            style: 'tableText'
          },
          {
            text: fullName,
            style: 'tableText'
          },
          {
            text: RISK_LEVELS[assessment.riskLevel] || '',
            style: 'tableText'
          },
          {
            text: assessment.riskLevel ? assessment.riskScore : '',
            style: 'tableText'
          }
        ]
      })
    ]
  }
})

export const SingleRowTable = ({ headerText, bodyText }) => ({
  style: 'table',
  table: {
    layout: {
      defaultBorder: false
    },
    headerRows: 1,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    widths: headerText.map((_h) => '*'),
    body: [
      headerText.map((text) => ({
        text,
        style: 'tableHeader'
      })),
      bodyText.map((text) => ({
        text,
        style: 'tableText'
      }))
    ]
  }
})

export const RiskAssessmentActionsTable = (riskAssessments) => ({
  style: 'table',
  table: {
    layout: {
      defaultBorder: false
    },
    headerRows: 1,
    widths: ['*', '*'],
    body: [
      [
        {
          text: 'Risk Assessment',
          style: 'tableHeader'
        },
        {
          text: 'Actions',
          style: 'tableHeader'
        }
      ],
      ...riskAssessments.map((assessment) => [
        {
          text: assessment.form.name,
          style: 'tableText'
        },
        {
          text: assessment.formData.actions,
          style: 'tableText'
        }
      ])
    ]
  }
})
